export const formatDiscount = (rule) => {
  if (!rule) return '';
  switch (rule.unit) {
    case 'IMPORTE': return '$' + rule.discount;
    case 'LTS': return rule.discount + ' lt';
    case 'KGS': return rule.discount + ' kg';
    default: return rule.discount + '%';
  }
};
